// src/features/dashboard/mockData/Employee/monthlyProductivity.mock.ts

import type {
  MonthlyProductivityResponse,
} from '../../types/Employee/monthlyProductivity.types';

export const monthlyProductivityMock:
  MonthlyProductivityResponse = {

  badgeText:
    'Current Period',

  averageProductivity:
    0,

  metrics: [],
};